import { twMerge } from 'tailwind-merge';
import {
  GetFishingWater_fishingWater_region,
  GetPlace_entry_region,
} from '../../../interfaces/graphql';
import { ExternalLink } from '../../Clickables/ExternalLink/ExternalLink';
import { Heading } from '../../Heading/Heading';
import { ArrowUpRightIcon } from '../../Icons/ArrowUpRightIcon';
import { Text } from '../../Text/Text';
import licenseIcon from '../assets/LicenseIcon.png';
import { NextImageWrapper } from '../../NextImage/NextImageWrapper';

export interface ILicenseSectionProps {
  region: GetFishingWater_fishingWater_region | GetPlace_entry_region;
  className?: string;
}

export const LicenseSection = ({ region, className }: ILicenseSectionProps) =>
  region.licenseInfoUrl ? (
    <div
      className={twMerge(
        'flex flex-row items-center gap-4 rounded-lg bg-lake-fog p-4 sm:mx-auto sm:max-w-md sm:gap-6 sm:p-6 md:p-8',
        className,
      )}
    >
      <NextImageWrapper
        wrapperClassName=""
        customPlaceholderClassName=""
        imageClassName="w-[70px] h-[70px] aspect-square object-contain"
        alt="License Icon"
        src={licenseIcon}
      />
      <div className="flex flex-col gap-1 sm:gap-2">
        <Heading as="span" variant="sm" className="mb-0">
          Local laws and licenses
        </Heading>
        <Text variant="sm" className="mb-0">
          {region.name} fishing license
        </Text>
        <ExternalLink
          href={region.licenseInfoUrl}
          className="heading-text-xxs constantSize flex items-center font-heading !font-medium text-trench"
          target="_blank"
          variant="textNone"
        >
          Get license <ArrowUpRightIcon />
        </ExternalLink>
      </div>
    </div>
  ) : (
    <></>
  );
